import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { WarningIcon } from "../../../../components/IconsSVG";
import AdminDropdown from "../../../../partials/content/CustomDropdowns/AdminDropdown";
import CrudActions from "../../../../partials/datatable/CrudActions";
import Datatable from "./Datatable";
import {
	StyledTableCell,
	StyledTableRow
} from "./styles";
import { MutantApiService } from "../../../../services/MutantApiService";
import Loading from "../../../home/components/Loading";
import { getStatusTranslation } from "../Prompts/PromptsListing";

export default function FailedAudioListing(props) {
	const api = new MutantApiService();
	
	const [stages, setStages] = useState([]);
	const [reload, setReload] = useState(false);
	const [loading, setLoading] = useState(true);
	const [inputSearch, setInputSearch] = React.useState("");

	useEffect(() => {
		setLoading(false);
	}, []);


	const handleIsRevised = async function (id) {
		try {
			setLoading(true);

			await api.makeHttpRequest({
				method: "POST",
				url: `/prompts/${id}/revised`,
				data: {}
			});

			setLoading(false);

			await Swal.fire({
				title: "Sucesso!",
				text: "Status alterado com sucesso.",
				icon: "success",
				cancelButtonText: "Sair"
			});
		} catch (e) {
			setLoading(false);
			await Swal.fire("Erro!", "Erro ao alterar status.", "error");
		} finally {
			setReload(!reload);
		}
	};

	window.setPageTitle("Listagem de prompts invalidados");

	const headRows = [
		{ column: "isRevised", label: "REVISADO", align: "left" },
		{ column: "reason", label: "MOTIVO", align: "left" },
		{ column: "text", label: "TEXTO/ARQUIVO", align: "left" },
		{ column: "voice", label: "MODELO", align: "left" },
		{ column: "status", label: "STATUS", align: "left" },
		{ column: "ouvir", label: "ÁUDIO", align: "left" },
		{ label: "AÇÕES", align: "center" },
	];

	const formatRow = prompt => {
		const crudActions = ["revise"];

		const getStatusColor = (status) => {
			switch (status) {
				case "ENQUEUED":
					return "#A3A3A3"

				case "PROCESSING":
					return "#00b300"

				case "PROCESSED":
					return "#1F7A1F"

				case "FAILED":
					return "#FFA31A"

				default:
					return "#000000"
			}
		}

		return (
			<StyledTableRow hover tabIndex={-1} key={prompt.id}>
				<StyledTableCell scope="row" width="20%" align="left">
					{prompt.isRevised ? "SIM" : "NÂO"}
				</StyledTableCell>
				<StyledTableCell scope="row" width="20%" align="left">
					{prompt.reason}
				</StyledTableCell>
				<StyledTableCell scope="row" width="25%" align="left">
					{prompt.text}
				</StyledTableCell>
				<StyledTableCell scope="row" width="10%" align="left">
					{prompt.speaker}
				</StyledTableCell>
				<StyledTableCell scope="row" width="10%" style={{ color: getStatusColor(prompt.status) }} align="left">
					{getStatusTranslation(prompt.status)}
				</StyledTableCell>
				<StyledTableCell scope="row" width="25%" align="left">
					<audio controls>
						<source src={prompt.path} type="audio/wav" />
					</audio>
				</StyledTableCell>
				<StyledTableCell scope="row" width="10%" align="center">
					<CrudActions
						onConfirmRevised={handleIsRevised}
						actions={crudActions}
						module="prompts"
						id={prompt.id}
						obj={prompt}
					/>
				</StyledTableCell>
			</StyledTableRow>
		);
	};


	const handleSetRows = rows => {
		setStages(rows);
	};

	return (
		<>
			<Loading isLoading={loading} />
			<Datatable
				title="Prompts invalidados"
				icon={WarningIcon}
				endpoint={`/prompts/invalidateds`}
				className="h-100"
				headRows={headRows}
				formatRow={formatRow}
				rows={stages}
				setRows={handleSetRows}
				setInputSearch={setInputSearch}
				inputSearch={inputSearch}
				reload={reload}
				placeholderSearch="Filtre por nome, modelo text ou motivo de falha"
				mobile={AdminDropdown}
				width={props.width}
				hiddenReload
				users
			/>
		</>
	);
}